import {Component, Prop, Vue} from "vue-property-decorator";
import {DataTable} from "~/components/data-table";
import {User} from "~/lib/models/user";
import {Role} from "~/modules/users/lib/roles-utils";
import {formatDate} from "~/lib/helpers/formatters";

@Component
export class UsersTable extends Vue {

  @Prop({type:Array, required:true}) users: User[];
  @Prop({type:Array, required:true}) roles: Role[];

  get headers(){
    return [
      {
        key: 'active',
        value: user => user.active ?
          <span class="active">Actif</span> :
          <span class="inactive">Inactif</span>,
        label: "Statut",
        type: 'boolean'
      },
      {
        key: 'email',
        value: user => user.email,
        label: "Email",
      },
      {
        key: 'profile.firstName',
        value: user => user.profile?.firstName || "-",
        label: "Prénom",
        type: "object",
      },
      {
        key: 'profile.lastName',
        value: user => user.profile?.lastName || "-",
        label: "Nom",
        type: "object",
      },
      {
        key: 'roleLabel',
        value: user => user.hasPrivateRole ? 'interne' : (user.roleLabel || "-"),
        label: "Rôle",
      },
      {
        key: 'createdAt',
        value: user => formatDate(user.createdAt, 'dd\/MM\/yyyy à HH:mm') || "-",
        label: "Date de création",
      },
    ];
  }


  render() {
    return  <DataTable
      headers={this.headers}
      tableData={this.users}
      onClickRow={user => this.$router.push({ name: "users-edit", params: {uuid: user.uuid}})}
    />
  }
}


// VUE JSX HOT LOADER //
if (module.hot) require("/usr/src/app/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-5450cf86/users-table.tsx" });